import { call, put, takeLatest } from "redux-saga/effects";
import {
  customerCountryFailure,
  customerCountrySuccess,
  customerCityFailure,
  customerCitySuccess,
  customerStateFailure,
  customerStateSuccess,
} from "./customerAddressAction";

import {
  GET_COUNTRY_REQUEST,
  GET_STATE_REQUEST,
  GET_CITY_REQUEST,
} from "./customerAddressTypes";

import {
  ViewAllCityEffect,
  ViewAllCountryEffect,
  ViewAllStateEffect,
} from "./customerAddressEffect";

// View All Country
function* viewAllCountrySaga(action) {
  try {
    const response = yield call(ViewAllCountryEffect, action.payload);
    if (response?.status === 200) {
      yield put(customerCountrySuccess({ ...response.data }));
    } else {
      const errorMessage = response.data.body?.error || "Failed to get country";
      throw new Error(errorMessage);
    }
  } catch (error) {
    const errorFields = error.response?.data?.errorFields || {};
    const message =
      error.response?.data?.message || "Failed to get all country";
    yield put(customerCountryFailure({ message, errorFields }));
  }
}

// View All State
function* viewAllStateSaga(action) {
  try {
    const response = yield call(ViewAllStateEffect, action.payload);
    if (response?.status === 200) {
      yield put(customerStateSuccess({ ...response.data }));
    } else {
      const errorMessage = response.data.body?.error || "Failed to get country";
      throw new Error(errorMessage);
    }
  } catch (error) {
    const errorFields = error.response?.data?.errorFields || {};
    const message =
      error.response?.data?.message || "Failed to get all country";
    yield put(customerStateFailure({ message, errorFields }));
  }
}

// View All City
function* viewAllCitySaga(action) {
  try {
    const response = yield call(ViewAllCityEffect, action.payload);
    if (response?.status === 200) {
      yield put(customerCitySuccess({ ...response.data }));
    } else {
      const errorMessage = response.data.body?.error || "Failed to get country";
      throw new Error(errorMessage);
    }
  } catch (error) {
    const errorFields = error.response?.data?.errorFields || {};
    const message =
      error.response?.data?.message || "Failed to get all country";
    yield put(customerCityFailure({ message, errorFields }));
  }
}

export function* CustomerAddressSaga() {
  yield takeLatest(GET_COUNTRY_REQUEST, viewAllCountrySaga);
  yield takeLatest(GET_STATE_REQUEST, viewAllStateSaga);
  yield takeLatest(GET_CITY_REQUEST, viewAllCitySaga);
}
